import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowId.actions.inviteUsers', {
    inviteUsersSuccess: '{count, plural, one {User} other {Users}} invited',
});
